'use strict';

function SettingsService ($sce, IdentityService, SaturnGrowl, statusFilter, UserStore) {
  //************ PUBLIC VARIABLES ************\\
  this.currentUser = UserStore.get('user') || IdentityService.get('user');
  this.currentOrganization = IdentityService.get('currentOrganization');

  this.hasMultipleOrganizations = this.currentUser && this.currentUser.organizations ? this.currentUser.organizations.length > 1 : false;

  this.OUT_OF_SEATS_ERROR = 'No more seats available in plan';
  this.NO_SEATS_REMAINING_ERROR = 'No seats remaining';
  this.PRICING_PAGE = $sce.trustAsResourceUrl('https://s3-us-west-2.amazonaws.com/assets.skycatch.com/pages/pricing.tpl.html');

  this.SUPPORT_LINK = '//support.skycatch.com/hc/en-us/categories/201644828-Skycatch-Dashboard';

  this.USER_DETAIL_STATE = 'settings.organization.users.detail';

  //************ PUBLIC METHODS ************\\
  this.generateGrowlData = function generateGrowlData (messageStub, idName) {
    return {
      message: ['Your subscription has been', messageStub].join(' '),
      id: [idName, Date.now()].join('-'),
      time: 2500
    };
  };

  this.generateGrowlId = function generateGrowlMessage (status, user) {
    var name = user.name.split(' ').join('').toLowerCase();

    return [name, status, Date.now()].join('-');
  };

  this.generateRequestGrowlMessage = function generateRequestGrowlMessage (org, user, status) {
    var name = user.name+ '\'';

    // only add 's to the end of the name if the name does not end in s
    if (name[name.length - 2] !== 's') {
      name += 's';
    }

    return [name, 'request to join', org.name, 'has been', status].join(' ');
  };

  /**
   * growl - description
   *
   * @param  {type} config object
   * Config MUST have message and id properties
   * *** AVAILABLE CONFIG SETTINGS ***
   * Message: {String} REQUIRED the text displayed in the growl
   * ID {String} REQUIRED internal growl identifier. should be unique to avoid conflicts with multiple growls being open simultaneously
   * Type {String} OPTIONAL determines the color of the growl. can be 'normal' (default), 'warning', or 'alert'
   * Time {Number} OPTIONAL the length of time (in milliseconds) that the growl will remain open. -1 is infinite
   * @return {type}        N/A
   */
  this.growl = function growl (config) {
    SaturnGrowl.newGrowl(config.message, {
      type: config.type || 'normal',
      time: config.time || 10000,
      id: config.id
    });
  };

}

SettingsService.$inject = ['$sce', 'IdentityService', 'SaturnGrowl', 'statusFilter', 'UserStore'];

module.exports = SettingsService;



// WEBPACK FOOTER //
// ./src/app/settings/SettingsService.js